import * as React from 'react';
import { useTextMessaging } from '../../../../models/hooks/appStateHooks';
import { useConversationsInfiniteQuery } from '../../../../queries';

export function useRefreshConversations() {
	const textMessagingVM = useTextMessaging();

	const query = useConversationsInfiniteQuery({
		enabled: Boolean(textMessagingVM?.id),
		meta: {
			errorLogging: {
				category: 'useRefreshConversations',
				action: 'ConversationsRefresh-Error',
			},
		},
		phoneNumberId: textMessagingVM?.id,
	});

	React.useEffect(() => {
		if (textMessagingVM?.id && !query.isFetching && query.data?.pages?.length) {
			textMessagingVM.addConversations(query.data.pages[0].values);
		}
	}, [query.data?.pages, query.isFetching, textMessagingVM]);
}
